export default "__VITE_ASSET__CLdxe3vS__"